
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/purolator",
      function () {
        return require("private-next-pages/partners/purolator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/purolator"])
      });
    }
  